import { render, staticRenderFns } from "./course_analyze.vue?vue&type=template&id=d72ef2ea&scoped=true&"
import script from "./course_analyze.vue?vue&type=script&lang=js&"
export * from "./course_analyze.vue?vue&type=script&lang=js&"
import style0 from "./course_analyze.vue?vue&type=style&index=0&id=d72ef2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72ef2ea",
  null
  
)

export default component.exports